import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { Pager } from '../../ui-parts/Pager';
import NewsManagementListTable from './NewsManagementListTable';

/**
 * NewsManagement List Component
 */
const NewsManagementList = ({ screenId, initNewsManagedPage, needsRefreshPage, setNeedsRefresh, setModalInfo }) => {
  
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const [pagingNewsManagedPage, setPagingNewsManagedPage] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isPaging, setIsPaging] = useState(false);
  const [isInitLoaded, setIsInitLoaded] = useState(false);

  // 初期表示
  useEffect(() => {
    setIsInitLoaded(true);
  }, []);

  // ページング
  useEffect(() => {
    // 初期表示時はなにも行わない
    if (isInitLoaded === false) { return; }
    requestPage(pageNumber);
  }, [pageNumber]);

  // ページングリロード
  useEffect(() => {
    if (needsRefreshPage === true) {
      if (pageNumber === 1) {
        requestPage(1);
      } else {
        setPageNumber(1);
      }
      setNeedsRefresh(false);
    }
  }, [needsRefreshPage]);

  /**
   * ページングリクエスト
   * @param {number} requestPageNumber ページ番号
   */
  const requestPage = (requestPageNumber) => {
    setIsPaging(true);

    const callbackRequestPage = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (requestPageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(requestPageNumber - 1);
        return;
      }
      setPagingNewsManagedPage(result);
      setIsPaging(false);
    }

    apiRequest.requestJson(`api/news/managed-page?LimitMaxRowCount=${screenSettings.MaxRowCount}&PageNumber=${requestPageNumber}`, 'GET', callbackRequestPage);
  }

  /** NewsTypeアイコン定義 */
  const iconControlList = {
    published: {
      control: (size) => <CheckCircleIcon color='success' sx={{ fontSize: size === 'large' ? '35px' : '20px' }} />,
      text: controlSettings.LabelList.lblPublishedIconTitle
    },
    unPublished: {
      control: (size) => <AddCircleIcon sx={{
        color: 'red',
        transform: 'rotate(45deg)',
        fontSize: size === 'large' ? '36px' : '21px',
      }} />,
      text: controlSettings.LabelList.lblUnpublishedIconTitle
    },
    linkError: {
      control: (size) => <ErrorIcon stroke='black' strokeWidth='1' sx={{ fill: 'yellow', fontSize: size === 'large' ? '35px' : '20px' }} />,
      text: controlSettings.LabelList.lblLinkErrorIconTitle
    },
  };

  const showNewsPage = pagingNewsManagedPage ?? initNewsManagedPage;

  return (
    <>
      {isPaging && <MyMProgress />}
      <Box>
        <MyMLabel className='ps-2' fontWeight='bold'>{controlSettings.LabelList.lblNewsList}</MyMLabel>
      </Box>
      <NewsManagementListTable
        newsManagedPage={showNewsPage}
        iconControlList={iconControlList}
        setModalInfo={setModalInfo}
        controlSettings={controlSettings}
        messageList={messageList} />
      {/* 一覧結果がある場合、アイコン凡例表示 */}
      {showNewsPage.ItemList.length > 0 &&
        <Stack direction='row' spacing={3} className='my-2'>
          {Object.keys(iconControlList).map((key) =>
            <Box key={key} className='d-flex'>
              {iconControlList[key].control('small')}
              <MyMLabel className='ps-1'>{iconControlList[key].text}</MyMLabel>
            </Box>
          )}
        </Stack>
      }
      {/* ページング */}
      <Pager
        resultListItem={showNewsPage}
        handleChangePage={(pageNum) => setPageNumber(pageNum)}
        labelList={controlSettings.LabelList}
        pageNumber={pageNumber}>
      </Pager>
    </>
  );
}
export default NewsManagementList;
